import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=29ee48a1&scoped=true&"
import script from "./FaqCategory.vue?vue&type=script&lang=js&"
export * from "./FaqCategory.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=29ee48a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ee48a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VSubheader})
